import React, { FC } from "react";

import "../styles.scss";
import "../scripts";

import {
  primaryBlock,
  PrimaryBlockConfig,
  getDefaultProps,
  KameleonElement,
  SecondaryBlockSize,
  TertiaryBlockSize,
  renderTertiaryBlock,
  BlockTheme,
  BlockType,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";

import { webflowHOC } from "@kameleon-common/webflow-js";
import { Variants } from "@kameleon-util/global-theme";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { MediaCollectionType, layoutOptions } from "./types/prop-types";

/** MediaCollection Primary */
const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.None,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockType: BlockType.Primary,
  blockTheme: BlockTheme.dark,
};

const MediaCollectionComponent: FC<MediaCollectionType> = ({
  tagline,
  TertiaryBlock,
  items,
  header,
  description,
  _internalProps,
}: MediaCollectionType) => (
  <Box
    className={
      _internalProps?._className ??
      "primary-media-collection-grid-square-images-v1"
    }
  >
    <Variants.Lightbox />
    <Box className="padding-global">
      <Box className="container-large">
        <Box className="padding-section-large">
          {(header || description) && (
            <Box className="margin-bottom margin-xxlarge">
              {tagline && (
                <Box className="margin-bottom margin-xsmall">
                  <Variants.TagLine>{tagline}</Variants.TagLine>
                </Box>
              )}
              <Box className="max-width-large align-center">
                {header && (
                  <Box className="margin-bottom margin-small">
                    <Variants.Heading>{header}</Variants.Heading>
                  </Box>
                )}
                {description && (
                  <Variants.ParagraphMedium>
                    {description}
                  </Variants.ParagraphMedium>
                )}
              </Box>
            </Box>
          )}
          <Box className="gallery6_row">
            {items?.map((item, index) => (
              <Variants.Link
                key={index}
                href="#"
                className="gallery6_lightbox-link w-inline-block w-lightbox"
              >
                <Box className="gallery6_image-wrapper">
                  <Variants.Image
                    src={item.image.url}
                    loading="lazy"
                    sizes="90vw"
                    alt={item.image.alt}
                    className="gallery6_image"
                  />
                </Box>
                <Variants.LightboxImage
                  image={item.image.url}
                  caption={item.caption}
                />
              </Variants.Link>
            ))}
          </Box>
          {renderTertiaryBlock(TertiaryBlock)}
        </Box>
      </Box>
    </Box>
  </Box>
);

export const MediaCollection = primaryBlock<MediaCollectionType>(
  blockConfig,
  webflowHOC(MediaCollectionComponent, ["lightbox"])
);

MediaCollection.defaultProps = getDefaultProps<MediaCollectionType>(defaults);

export const Element: KameleonElement = {
  component: MediaCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
